module.exports = "new-file";


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file1/new-file.js
 ** module id = 16
 ** module chunks = 0
 **/